import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_employee_branch_designation_link_RowClass} from '../../dbschema';

export class BranchDesignationEmployeeLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_employee_branch_designation_link: bl_fi_mst_employee_branch_designation_link_RowClass = new bl_fi_mst_employee_branch_designation_link_RowClass();
}
